<template>
  <div>
    <search-nav @handleSearch="handleSearch">
      <search-nav-start-end label="팝업노출기간" v-model="searchDate"/>
      <search-nav-item-select label="검색조건" v-model="searchType" :list="searchTypes" />
      <search-nav-item-keyword label="키워드" v-model="searchKeyword" @keyup.enter="handleSearch" />
    </search-nav>

    <vs-row class="mb-4">
      <vs-col class="flex" vs-justify="flex-end">
        <vs-button v-if="permission.c" color="secondary" @click="handleClickRegister">신규작성</vs-button>
      </vs-col>
    </vs-row>

    <vs-row>
      <vs-col>
        <vs-table stripe
                  ref="table"
                  :sst="true"
                  :max-items="table.perPage"
                  :data="table.list"
                  @selected="handleItemClickDetail"
                  noDataText="데이터가 없습니다"
        >
          <template slot="thead">
            <vs-th><span class="w-full text-center">No.</span></vs-th>
            <vs-th><span class="w-full text-center">종류</span></vs-th>
            <vs-th><span class="w-full text-center">제목</span></vs-th>
            <vs-th><span class="w-full text-center">팝업 노출 여부</span></vs-th>
            <vs-th><span class="w-full text-center">작성자</span></vs-th>
            <vs-th><span class="w-full text-center">등록일</span></vs-th>
          </template>


          <template slot-scope="{data}">
            <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
              <vs-td class="text-center">{{ getNo(indextr) }}</vs-td>
              <vs-td class="text-center">{{ getContent(tr).noticeName }}</vs-td>
              <vs-td class="text-center">{{ getContent(tr).title }}</vs-td>
              <vs-td class="text-center">
                <div>
                  <div v-html="getShowDate(tr).html"></div>
                </div>
              </vs-td>
              <vs-td class="text-center">{{ getContent(tr).writer }}</vs-td>
              <vs-td class="text-center">{{ tr.created_at | date }}</vs-td>
            </vs-tr>
          </template>
        </vs-table>

        <div class="vs-con-table">
          <div class="con-pagination-table vs-table--pagination">
            <k-pagination
              :total="(lastPage) ? lastPage : 1"
              v-model="currentPage" @change="handleChangePage"></k-pagination>
          </div>
        </div>
      </vs-col>
    </vs-row>
  </div>
</template>

<script>
import TemplateListNormal from '@/views/community/template/TemplateListNormal'
import SearchNavItemSelect from '@/components/nav/SearchNavItemSelect'
import SearchNavItemKeyword from '@/components/nav/SearchNavItemKeyword'
import SearchNav from '@/components/nav/SearchNav'
import KPagination from '@/components/kPagination/kPagination'
import SearchNavStartEnd from "@/components/nav/SearchNavStartEnd.vue";

export default {
  name: 'CommunityBusinessNews',
  components: {
    SearchNavStartEnd,
    KPagination,
    SearchNav,
    SearchNavItemKeyword,
    SearchNavItemSelect,
    TemplateListNormal
  },
  computed: {
    projectId () {
      return this.$route.params.proj_id
    },
  },
  data () {
    return {
      boardSlug: 'news',
      boardId: 612,
      viewTypeCode: 'normal',
      perPageOption: '10,20,30',
      projectTitle: '',
      table: {
        list: [],
        perPage: 7,
        keyword: ''
      },

      //pagination
      perPage: 10,
      date: '',
      searchKeyword: '',
      searchTypes: [
        {text:'제목', value:'body.title'},
        {text:'작성자', value:'body.writer'},
      ],
      searchDate: {
        sDate: '',
        eDate: ''
      },
      searchType: 'body.title',
      currentPage: 1,
      lastPage: 1,
      total: 0,
      permission: {
        c: false,
        r: false,
        u: false,
        d: false,
      },
    }
  },

  async created () {
    const paths = this.$route.path.split('/')
    this.rootPath = `/${paths[1]}/${paths[2]}`

    // 게시판일 경우, 권한을 확인한다
    if (Number.isInteger(parseInt(this.boardId))) {
      let boards = this.$store.state.member.memberInfo.boards;
      if (!boards) {
        await this.$store.dispatch("member/LOAD_MEMBER_DETAIL");
        boards = this.$store.state.member.memberInfo.boards;
      }

      let board = boards.find((b) => parseInt(b.id) === parseInt(this.boardId));
      if (!!board && !!board.pivot) {
        if (this.projectId && board.pivot.project_id) {
          // 프로젝트에 맞는 권한이 있는지 다시 조사한다
          board = boards.find((b) => parseInt(b.pivot.board_id) === parseInt(this.boardId) && parseInt(b.pivot.project_id) === parseInt(this.projectId));
          this.permission = { ...board.pivot };
        } else {
          this.permission = { ...board.pivot };
        }
      }
    }

    await this.loadPostList()
  },

  methods: {

    getNo (index) {
      return this.total - (((this.currentPage - 1) * this.perPage) + index)
    },

    // 게시물 불러오기
    async loadPostList () {
      const projectId = this.projectId
      const boardId = this.boardId
      const page = (this.currentPage) ? this.currentPage : 1
      const perPage = this.perPage
      const sDate = this.searchDate.sDate
      const eDate = this.searchDate.eDate

      const conditions = []
      if (sDate) {
        conditions.push({
          key: 'body.options.endDate',
          operator: '>=',
          value: sDate
        })
      }
      if (eDate) {
        conditions.push({
          key: 'body.options.beginDate',
          operator: '<=',
          value: eDate
        })
      }
      if (this.searchKeyword) {
        conditions.push({
          key: this.searchType,
          operator: 'LIKE',
          value: `%${this.searchKeyword}%`
        })
      }

      console.log("conditions", conditions)
      await this.$store.dispatch('board/LOAD_POST_LIST', {
        projectId,
        boardId,
        page,
        perPage,
        orderTarget: 'id',
        orderDirection: 'desc',
        conditions,
      })

      // 게시물 불러오기
      const postListInfo = this.$store.state.board.postListInfo

      // 페이지네이션 정보
      this.currentPage = postListInfo.current_page
      this.lastPage = postListInfo.last_page
      this.perPage = postListInfo.per_page
      this.total = postListInfo.total

      // 보여지는 게시물 리스트
      const list = postListInfo.data
      const newList = []
      for (const item of list) {
        newList.push(item)
        if (item.children.length > 0) {
          for (const subItem of item.children) {
            newList.push(subItem)
          }
        }
      }


      this.table.list = newList

    },

    getContent (data) {
      if (data.post_content) {
        const content = JSON.parse(data.post_content).body
        return content
      }
    },

    getShowDate (data) {
      if (this.getContent(data).open) {
        const beginDate = this.getContent(data).options.beginDate
        const endDate = this.getContent(data).options.endDate
        const skipDate = this.getContent(data).options.skipDate

        let html = '<div style="display: inline-grid; grid-template-columns: 56px 1fr; row-gap: 0.3rem; column-gap: 0.5rem; text-align:left">'
        html += '<div style="grid-row:1/3; grid-column: 1/2; display: flex; align-items: center;"><span style="padding: 0.5rem 1rem; border-radius: 8px; background: #7E72F2; color: #fff;">팝업</span></div>'
        if (beginDate || endDate) {
          html += `<span style="grid-column: 2/3">${beginDate} ~ ${endDate}</span>`
        }
        if (`${skipDate}` === '1') {
          html += '<span style="grid-column: 2/3">오늘 하루 보지 않기</span>'
        }
        else if (`${skipDate}` === '7') {
          html += '<span style="grid-column: 2/3">7일간 하루 보지 않기</span>'
        }
        html += '</div>'
        return {
          type: 'html',
          html
        }
      } else {
        return '-'
      }
    },

    getDate (date) {
      return new Date(date).format('yyyy-MM-dd')
    },

    handleChangePerPage (_data) {
      if (this.perPage !== _data) {
        this.currentPage = 1
        this.perPage = _data
        this.loadPostList()
      }
    },
    handleSearch () {
      this.currentPage = 1
      this.loadPostList()
    },
    handleChangePage (_data) {
      if (this.currentPage !== _data) {
        this.currentPage = _data
        this.loadPostList()
      }
    },
    handleItemClickDetail (_data) {
      this.moveProjectDetail(_data.id)
    },

    // 글 상세페이지로 이동
    moveProjectDetail (_postId) {
      const project_id = parseInt(this.$route.params.proj_id)
      if (project_id) {
        this.$router.push({path: `/project/${project_id}/community/popup-notice/${_postId}/update`})
      } else {
        this.$router.push({path: `/community/popup-notice/${_postId}/update`})
      }

    },
    handleClickRegister () {
      const project_id = parseInt(this.$route.params.proj_id)
      if (project_id) {
        this.$router.push({path: `/project/${project_id}/community/popup-notice/create`})
      } else {
        this.$router.push({path: '/community/popup-notice/create'})
      }
    }
  }
}
</script>

<style scoped>

</style>
